import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { cloneDeep, isEqual } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_SHOW_HIDE_DATA } from "../../bell-curve-report-parameter/reducers/bell-curve-report-parameter-reducer";
import MdaeButton from "../button";
import MdaeDataGrid, { IMdaeDataGridProps } from "../data-grid";
import "./index.scss";
interface IShowHideTable {
    LHSList: any[],
    RHSList: any[],
    widgetKey: string,
    displayExpr: string,
    rowIndex: number
}

const ShowHideTable: React.FC<IShowHideTable> = (props) => {
    const [selectedLHSItems, setselectedLHSItems] = useState([]);
    const [selectedRHSItems, setselectedRHSItems] = useState([]);
    const dispatch = useDispatch();
    const setShowHideData = (LHSList, RHSList, widgetKey, rowIndex) => {
        dispatch({
            type: SET_SHOW_HIDE_DATA,
            data: {
                hideItems: LHSList,
                showItems: RHSList,
                widgetKey: widgetKey,
                rowIndex: rowIndex
            },
        });
    }
    useEffect(() => {
        let newRHSList = props.RHSList;
        props.LHSList?.forEach(function (item) {
            newRHSList = newRHSList?.filter((x) => x.id != item.id);
        });
        setShowHideData(props.LHSList, newRHSList, props.widgetKey, props.rowIndex);
    }, [props.widgetKey]);
    const showHideLHSData = useSelector(
        (state: any) =>
            state.bellCurveReportParameterReducer[props.widgetKey + "showHideLHSData"]
        , isEqual);
    const showHideRHSData = useSelector(
        (state: any) =>
            state.bellCurveReportParameterReducer[props.widgetKey + "showHideRHSData"]
        , isEqual);


    const showHideRightDatagridProps = useMemo(
        () => getshowHideRightDatagridProps(props.widgetKey, setselectedRHSItems, props.displayExpr),
        [showHideRHSData]
    );


    const showHideLeftDatagridProps = useMemo(
        () => getshowHideLeftDatagridProps(props.widgetKey, setselectedLHSItems, props.displayExpr),
        [showHideLHSData]
    );
    return (<div>
        <table className="rowSection">
            <tr>
                <td className="leftSection">
                    <MdaeDataGrid
                        id="grdShowHideLeftTable"
                        className="bottom-margin"
                        {...showHideLeftDatagridProps}
                        dataSource={showHideLHSData}
                    />
                </td>
                <td className="middleSection">
                    <div>
                        <span
                            className="arrow-right-icon"
                            onClick={() => {
                                let tempShowHideLHSData = cloneDeep(showHideLHSData);
                                let tempShowHideRHSData = cloneDeep(showHideRHSData);
                                if (selectedLHSItems.length > 0) {
                                    selectedLHSItems.forEach(function (item) {
                                        tempShowHideRHSData.push(item);
                                        tempShowHideLHSData.splice(tempShowHideLHSData.findIndex(x => x.id == item.id), 1);
                                    })
                                }
                                setShowHideData(tempShowHideLHSData, tempShowHideRHSData, props.widgetKey, props.rowIndex);
                            }}
                            title="Add Selected Report Parameter"
                            aria-label="Add Selected Report Parameter"
                            role="button"
                        ></span>
                    </div>
                    <div>
                        <span
                            className="arrow-left-icon"
                            onClick={() => {
                                let tempShowHideLHSData = cloneDeep(showHideLHSData);
                                let tempShowHideRHSData = cloneDeep(showHideRHSData);
                                if (selectedRHSItems.length > 0) {
                                    selectedRHSItems.forEach(function (item) {
                                        tempShowHideLHSData.push(item);
                                        tempShowHideRHSData.splice(tempShowHideRHSData.findIndex(x => x.id == item.id), 1);
                                    })
                                }
                                setShowHideData(tempShowHideLHSData, tempShowHideRHSData, props.widgetKey, props.rowIndex);
                            }}
                            title="Add Selected Report Parameter"
                            aria-label="Add Selected Report Parameter"
                            role="button"
                        ></span>
                    </div>
                </td>
                <td className="rightSection">
                    <MdaeDataGrid
                        id="grdShowHideRightTable"
                        className="bottom-margin"
                        {...showHideRightDatagridProps}
                        dataSource={showHideRHSData}
                    />
                </td>
            </tr>
        </table>
    </div>);
};

const getshowHideLeftDatagridProps = (widgetKey, setselectedLHSItems, displayExpr) => {
    const showHideLeftDataGridConfig: IMdaeDataGridProps = {
        id: widgetKey + "grdHideTable",
        height: 250,
        allowColumnReordering: false,
        wordWrapEnabled: true,
        loadPanel: { enabled: true },
        headerFilter: { visible: false },
        filterRow: { visible: true },
        paging: { enabled: false },
        hoverStateEnabled: true,
        scrolling: { mode: 'standard' },
        columnAutoWidth: true,
        columnFixing: { enabled: true },
        allowColumnResizing: false,
        selection: { mode: 'multiple', showCheckBoxesMode: 'always' },
        onSelectionChanged: function (e) {
            setselectedLHSItems(e.selectedRowsData)
        },
        mdaeColumns: [
            {
                dataField: displayExpr,
                caption: 'Hide',
                allowFiltering: true,
                fixed: false,
                allowSorting: true,
                sortOrder: "asc",
            }
        ],
    };
    return showHideLeftDataGridConfig;
};
const getshowHideRightDatagridProps = (widgetKey, setselectedRHSItems, displayExpr) => {
    const showHideRightDataGridConfig: IMdaeDataGridProps = {
        id: widgetKey + "grdShowTable",
        height: 250,
        allowColumnReordering: false,
        wordWrapEnabled: true,
        loadPanel: { enabled: true },
        headerFilter: { visible: false },
        filterRow: { visible: true },
        paging: { enabled: false },
        hoverStateEnabled: true,
        scrolling: { mode: 'standard' },
        columnAutoWidth: true,
        columnFixing: { enabled: true },
        allowColumnResizing: false,
        selection: { mode: 'multiple', showCheckBoxesMode: 'always' },
        onSelectionChanged: function (e) {
            setselectedRHSItems(e.selectedRowsData)
        },
        mdaeColumns: [
            {
                dataField: displayExpr,
                caption: "Show",
                allowFiltering: true,
                fixed: false,
                allowSorting: true,
                sortOrder: "asc",
            }
        ]
    };
    return showHideRightDataGridConfig;
};
export default ShowHideTable;